const dataChart = [
  {
    time: 1628812800,
    close: 47019.3,
    high: 48164,
    low: 44251.2,
    open: 44401.1,
    volumefrom: 8887.71,
    volumeto: 414498473.08,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1629072000,
    close: 44714.7,
    high: 48072.6,
    low: 44250,
    open: 47019.3,
    volumefrom: 9245.21,
    volumeto: 424312258.35,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1629331200,
    close: 48865.4,
    high: 49790,
    low: 44000,
    open: 44714.7,
    volumefrom: 8866.39,
    volumeto: 422111168.82,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1629590400,
    close: 47725.4,
    high: 50500,
    low: 47601.1,
    open: 48865.4,
    volumefrom: 8008.73,
    volumeto: 393966157.15,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1629849600,
    close: 49074.9,
    high: 49350,
    low: 46284.8,
    open: 47725.4,
    volumefrom: 8481.43,
    volumeto: 404997423.99,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1630108800,
    close: 46985.7,
    high: 49653.9,
    low: 46861.6,
    open: 49074.9,
    volumefrom: 6061.32,
    volumeto: 293471601.77,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1630368000,
    close: 49290.3,
    high: 50372.9,
    low: 46550,
    open: 46985.7,
    volumefrom: 8225.49,
    volumeto: 398825378.37,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1630627200,
    close: 51767.9,
    high: 51890.9,
    low: 48356,
    open: 49290.3,
    volumefrom: 7040.87,
    volumeto: 353781459.07,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1630886400,
    close: 46073.4,
    high: 52900,
    low: 42000,
    open: 51767.9,
    volumefrom: 15263.81,
    volumeto: 739503259.03,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1631145600,
    close: 45137.4,
    high: 47399,
    low: 44135.2,
    open: 46073.4,
    volumefrom: 6871.81,
    volumeto: 314897404.3,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1631404800,
    close: 47145.9,
    high: 47260,
    low: 43374.9,
    open: 45137.4,
    volumefrom: 6989.72,
    volumeto: 317457458.58,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1631664000,
    close: 47269.7,
    high: 48485.8,
    low: 46744,
    open: 47145.9,
    volumefrom: 6541.21,
    volumeto: 311869537.89,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1631923200,
    close: 42992.9,
    high: 48800,
    low: 42510,
    open: 47269.7,
    volumefrom: 8252.38,
    volumeto: 374364044.65,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1632182400,
    close: 44889.8,
    high: 45000,
    low: 39579,
    open: 42992.9,
    volumefrom: 14941.4,
    volumeto: 637414930.74,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1632441600,
    close: 43204.6,
    high: 45153,
    low: 40750,
    open: 44889.8,
    volumefrom: 7721.71,
    volumeto: 329397781.85,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1632700800,
    close: 41524.8,
    high: 44333,
    low: 40772.2,
    open: 43204.6,
    volumefrom: 5917.87,
    volumeto: 250293939.7,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1632960000,
    close: 47662,
    high: 48475,
    low: 41423.7,
    open: 41524.8,
    volumefrom: 11187.37,
    volumeto: 513068536.72,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1633219200,
    close: 51487,
    high: 51888,
    low: 46895.8,
    open: 47662,
    volumefrom: 8529.38,
    volumeto: 420888671.09,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1633478400,
    close: 53960.5,
    high: 56114.1,
    low: 50366.4,
    open: 51487,
    volumefrom: 13134.86,
    volumeto: 708223856.83,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1633737600,
    close: 57499.5,
    high: 57837.7,
    low: 53700,
    open: 53960.5,
    volumefrom: 6321,
    volumeto: 352920187.08,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1633996800,
    close: 57377.6,
    high: 58580.4,
    low: 54019.2,
    open: 57499.5,
    volumefrom: 9312.8,
    volumeto: 526492941.16,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1634256000,
    close: 61526.5,
    high: 62887.5,
    low: 56888.5,
    open: 57377.6,
    volumefrom: 9277.65,
    volumeto: 561812123.86,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1634515200,
    close: 66035.8,
    high: 66982.2,
    low: 59900,
    open: 61526.5,
    volumefrom: 10524.08,
    volumeto: 667156168.16,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1634774400,
    close: 61296.9,
    high: 66637.8,
    low: 54100,
    open: 66035.8,
    volumefrom: 10754.12,
    volumeto: 675989830.16,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1635033600,
    close: 60310.2,
    high: 63700,
    low: 59523,
    open: 61296.9,
    volumefrom: 6275.41,
    volumeto: 387557851.9,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1635292800,
    close: 62246.5,
    high: 62950,
    low: 57948,
    open: 60310.2,
    volumefrom: 11211.61,
    volumeto: 676029831.42,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1635552000,
    close: 60954.5,
    high: 62500,
    low: 59449.1,
    open: 62246.5,
    volumefrom: 5374.13,
    volumeto: 329135740.9,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1635811200,
    close: 61449,
    high: 64327,
    low: 60644.2,
    open: 60954.5,
    volumefrom: 7199.61,
    volumeto: 450049994.83,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1636070400,
    close: 63317.8,
    high: 63317.8,
    low: 60129.8,
    open: 61449,
    volumefrom: 4323.41,
    volumeto: 266278225.95,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1636329600,
    close: 64969,
    high: 68991,
    low: 62700.1,
    open: 63317.8,
    volumefrom: 13345.79,
    volumeto: 885527162.32,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1636588800,
    close: 64393.1,
    high: 65611.8,
    low: 62300.5,
    open: 64969,
    volumefrom: 6151.56,
    volumeto: 394710156.48,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1636848000,
    close: 60137.2,
    high: 66349.6,
    low: 58630,
    open: 64393.1,
    volumefrom: 9204.78,
    volumeto: 574657319.8,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1637107200,
    close: 58099.6,
    high: 60964.4,
    low: 55674,
    open: 60137.2,
    volumefrom: 9946.04,
    volumeto: 584080736.13,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1637366400,
    close: 56295.5,
    high: 60050,
    low: 55633.6,
    open: 58099.6,
    volumefrom: 7038.26,
    volumeto: 408832810.1,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1637625600,
    close: 58932.6,
    high: 59400,
    low: 55362.7,
    open: 56295.5,
    volumefrom: 9089.5,
    volumeto: 520892911.58,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1637884800,
    close: 57300,
    high: 59193.8,
    low: 53300,
    open: 58932.6,
    volumefrom: 11202.52,
    volumeto: 615709671.5,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1638144000,
    close: 57237.9,
    high: 59230,
    low: 55932.6,
    open: 57300,
    volumefrom: 11071.57,
    volumeto: 637522013.08,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1638403200,
    close: 49255.1,
    high: 57688.9,
    low: 40150.1,
    open: 57237.9,
    volumefrom: 16529.48,
    volumeto: 853907306.74,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1638662400,
    close: 50650.1,
    high: 51955,
    low: 47210,
    open: 49255.1,
    volumefrom: 10525.65,
    volumeto: 520909954.88,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1638921600,
    close: 47218.3,
    high: 51202.5,
    low: 46888.8,
    open: 50650.1,
    volumefrom: 9012.54,
    volumeto: 442238323.4,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1639180800,
    close: 46732.2,
    high: 50788.4,
    low: 45759,
    open: 47218.3,
    volumefrom: 9006.2,
    volumeto: 434964133.18,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1639440000,
    close: 47631,
    high: 49512.5,
    low: 46313.7,
    open: 46732.2,
    volumefrom: 11426.57,
    volumeto: 548313707.8,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1639699200,
    close: 46688.4,
    high: 48289,
    low: 45500,
    open: 47631,
    volumefrom: 7731.19,
    volumeto: 362085984.03,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1639958400,
    close: 48624.9,
    high: 49599.8,
    low: 45600,
    open: 46688.4,
    volumefrom: 8904.88,
    volumeto: 426812549.71,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1640217600,
    close: 50436,
    high: 51844.4,
    low: 48042.3,
    open: 48624.9,
    volumefrom: 6665.25,
    volumeto: 335760474.97,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1640476800,
    close: 47548.1,
    high: 52111,
    low: 47305.5,
    open: 50436,
    volumefrom: 6347.79,
    volumeto: 315970410.43,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1640736000,
    close: 46150,
    high: 48591.6,
    low: 45530.3,
    open: 47548.1,
    volumefrom: 7388.27,
    volumeto: 348751189.12,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1640995200,
    close: 46452.6,
    high: 47950.4,
    low: 45707.9,
    open: 46150,
    volumefrom: 5610.59,
    volumeto: 263280147.57,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1641254400,
    close: 43124.4,
    high: 47500,
    low: 42424,
    open: 46452.6,
    volumefrom: 11085.07,
    volumeto: 491917038.99,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1641513600,
    close: 41862.9,
    high: 43134.9,
    low: 40555,
    open: 43124.4,
    volumefrom: 10342.64,
    volumeto: 431821311.92,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1641772800,
    close: 41906.3,
    high: 42239.6,
    low: 41613.2,
    open: 41862.9,
    volumefrom: 538.05,
    volumeto: 22549922.11,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
];

const rechartLineData = [
  {
    time: 1607558400,
    close: 18806.9,
    high: 18986.9,
    low: 17,
    open: 18548.5,
    volumefrom: 15678.24,
    volumeto: 285380877.28,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1607817600,
    close: 19439.7,
    high: 19551.5,
    low: 18,
    open: 18806.9,
    volumefrom: 13433,
    volumeto: 258481061.51,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1608076800,
    close: 23130.5,
    high: 23751,
    low: 19,
    open: 19439.7,
    volumefrom: 36890.87,
    volumeto: 812678290.05,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1608336000,
    close: 22716.1,
    high: 24297.7,
    low: 21,
    open: 23130.5,
    volumefrom: 22914.41,
    volumeto: 534113266.44,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1608595200,
    close: 23718.6,
    high: 24080,
    low: 22,
    open: 22716.1,
    volumefrom: 19361.93,
    volumeto: 451502045.23,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1608854400,
    close: 26251.4,
    high: 28353.2,
    low: 23,
    open: 23718.6,
    volumefrom: 30088.82,
    volumeto: 783317281.69,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1609113600,
    close: 28879.9,
    high: 28972.1,
    low: 25,
    open: 26251.4,
    volumefrom: 26999.08,
    volumeto: 738026849.67,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1609372800,
    close: 32238.8,
    high: 33245,
    low: 27,
    open: 28879.9,
    volumefrom: 33087.34,
    volumeto: 1011116724.77,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1609632000,
    close: 34050,
    high: 34771,
    low: 27,
    open: 32238.8,
    volumefrom: 39246.4,
    volumeto: 1264872411.43,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1609891200,
    close: 40666.7,
    high: 41989,
    low: 33,
    open: 34050,
    volumefrom: 42594.82,
    volumeto: 1614541768.07,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1610150400,
    close: 35439.3,
    high: 41437.5,
    low: 30,
    open: 40666.7,
    volumefrom: 47631.95,
    volumeto: 1716209084.66,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1610409600,
    close: 39151.6,
    high: 40115,
    low: 32,
    open: 35439.3,
    volumefrom: 37376.28,
    volumeto: 1340278767.62,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1610668800,
    close: 35816.4,
    high: 39686.1,
    low: 33,
    open: 39151.6,
    volumefrom: 31346.63,
    volumeto: 1140191107.05,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1610928000,
    close: 35511.8,
    high: 37860,
    low: 33,
    open: 35816.4,
    volumefrom: 22934.61,
    volumeto: 821791253.67,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1611187200,
    close: 32100.5,
    high: 35614.1,
    low: 28,
    open: 35511.8,
    volumefrom: 40868.54,
    volumeto: 1305107682.98,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1611446400,
    close: 32501,
    high: 34872.7,
    low: 30,
    open: 32100.5,
    volumefrom: 22817.13,
    volumeto: 741060975.28,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1611705600,
    close: 34261.7,
    high: 38621,
    low: 29,
    open: 32501,
    volumefrom: 40816.47,
    volumeto: 1362999278.44,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1611964800,
    close: 33533.9,
    high: 34902,
    low: 32,
    open: 34261.7,
    volumefrom: 15355.03,
    volumeto: 516591520.26,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1612224000,
    close: 36979,
    high: 38735.1,
    low: 33,
    open: 33533.9,
    volumefrom: 19686.44,
    volumeto: 715385712.52,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1612483200,
    close: 38874.9,
    high: 40986,
    low: 36,
    open: 36979,
    volumefrom: 19076.89,
    volumeto: 742361006.85,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1612742400,
    close: 44847.5,
    high: 48222,
    low: 38,
    open: 38874.9,
    volumefrom: 30708.18,
    volumeto: 1375636152.38,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1613001600,
    close: 47199.9,
    high: 48925,
    low: 44,
    open: 44847.5,
    volumefrom: 15931.09,
    volumeto: 752055282.31,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1613260800,
    close: 49218.7,
    high: 50599.9,
    low: 45,
    open: 47199.9,
    volumefrom: 15073.64,
    volumeto: 729844373.98,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1613520000,
    close: 55926.9,
    high: 56349.9,
    low: 48,
    open: 49218.7,
    volumefrom: 19503.2,
    volumeto: 1019627724.93,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1613779200,
    close: 54154.8,
    high: 58339,
    low: 45,
    open: 55926.9,
    volumefrom: 21898.51,
    volumeto: 1199064968.94,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1614038400,
    close: 47061.5,
    high: 54200,
    low: 45,
    open: 54154.8,
    volumefrom: 32730.55,
    volumeto: 1603713454.48,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1614297600,
    close: 45245.4,
    high: 48449,
    low: 32,
    open: 47061.5,
    volumefrom: 21128.45,
    volumeto: 970946304.37,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1614556800,
    close: 50400,
    high: 52600,
    low: 65,
    open: 1240.62,
    volumefrom: 19590.98,
    volumeto: 961581274.76,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1614816000,
    close: 48899.9,
    high: 51820.4,
    low: 46,
    open: 50400,
    volumefrom: 17812.45,
    volumeto: 864129943.9,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1615075200,
    close: 54929,
    high: 54929,
    low: 48,
    open: 48899.9,
    volumefrom: 15079.49,
    volumeto: 782752948.43,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1615334400,
    close: 57234,
    high: 58150.1,
    low: 53,
    open: 54929,
    volumefrom: 19174.14,
    volumeto: 1077498915.8,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1615593600,
    close: 55600,
    high: 61724.6,
    low: 54,
    open: 57234,
    volumefrom: 17359.54,
    volumeto: 1019125848.82,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1615852800,
    close: 57640.9,
    high: 60000,
    low: 52,
    open: 55600,
    volumefrom: 18721.71,
    volumeto: 1060323455.73,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1616112000,
    close: 57378.4,
    high: 59880,
    low: 55,
    open: 57640.9,
    volumefrom: 11141.08,
    volumeto: 646664284.39,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1616371200,
    close: 52293.8,
    high: 58403.2,
    low: 51,
    open: 57378.4,
    volumefrom: 19086.73,
    volumeto: 1051723718.57,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1616630400,
    close: 55852.4,
    high: 56668,
    low: 50,
    open: 52293.8,
    volumefrom: 15405.82,
    volumeto: 820089461.3,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1616889600,
    close: 58781,
    high: 59380,
    low: 54,
    open: 55852.4,
    volumefrom: 13389.13,
    volumeto: 766305924.19,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1617148800,
    close: 59020.7,
    high: 60025,
    low: 56,
    open: 58781,
    volumefrom: 12100.94,
    volumeto: 712906049.4,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1617408000,
    close: 59120,
    high: 59867.1,
    low: 56,
    open: 59020.7,
    volumefrom: 9164.5,
    volumeto: 534076742.62,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1617667200,
    close: 58036.9,
    high: 59462.8,
    low: 55,
    open: 59120,
    volumefrom: 10218.09,
    volumeto: 585532659.72,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1617926400,
    close: 59956,
    high: 61207,
    low: 57,
    open: 58036.9,
    volumefrom: 11606.49,
    volumeto: 689418209.65,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1618185600,
    close: 62969,
    high: 64900,
    low: 59,
    open: 59956,
    volumefrom: 15884.73,
    volumeto: 988728774.91,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1618444800,
    close: 60085.2,
    high: 63830,
    low: 59,
    open: 62969,
    volumefrom: 11830.78,
    volumeto: 731045319.14,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1618704000,
    close: 56500,
    high: 60403.2,
    low: 51,
    open: 60085.2,
    volumefrom: 27031.49,
    volumeto: 1504553858.01,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1618963200,
    close: 51178.7,
    high: 56805.5,
    low: 47,
    open: 56500,
    volumefrom: 26091.45,
    volumeto: 1358737282.09,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1619222400,
    close: 54051.9,
    high: 54419.5,
    low: 47,
    open: 51178.7,
    volumefrom: 16008.01,
    volumeto: 814088477.82,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1619481600,
    close: 53579.6,
    high: 56500,
    low: 52,
    open: 54051.9,
    volumefrom: 11428.94,
    volumeto: 620693172.7,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1619740800,
    close: 56618.5,
    high: 58525.5,
    low: 53,
    open: 53579.6,
    volumefrom: 9876.56,
    volumeto: 560035313.25,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1620000000,
    close: 57497.1,
    high: 58981.4,
    low: 53,
    open: 56618.5,
    volumefrom: 15132.18,
    volumeto: 849598780.75,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1620259200,
    close: 58953.8,
    high: 59521.4,
    low: 55,
    open: 57497.1,
    volumefrom: 12626.63,
    volumeto: 726658392.57,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
  {
    time: 1620518400,
    close: 58241.4,
    high: 59264,
    low: 57,
    open: 58953.8,
    volumefrom: 1713.35,
    volumeto: 100292545.79,
    conversionType: 'force_direct',
    conversionSymbol: '',
  },
];

export { rechartLineData, dataChart };
